import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { useSkinAnalyzerBrandData } from '../hooks/useSkinAnalyzerBrandData';
import { skinAnalyserMessages } from '../messages';
import { StyledDescription } from '../styled';

export const Description = () => {
  const brand = useSkinAnalyzerBrandData();

  return (
    <StyledDescription>
      <FormattedMessage
        {...skinAnalyserMessages.skinAnalyserDescriptionVariant}
        values={{ brandName: brand?.brandName }}
      />
    </StyledDescription>
  );
};
